import { Bucket } from "../../sdk/types/data";

interface PositionCloseTabProps {
  buckets: Bucket[];
  selectedMarketId: string | number | null;
}

export default function PositionCloseTab({
  buckets,
  selectedMarketId,
}: PositionCloseTabProps) {
  return (
    <div style={{ marginTop: "20px" }}>
      <div className="hooks-test-form-grid">
        <div>
          <label className="hooks-test-label">
            Market ID:
            <input
              type="text"
              className="hooks-test-input"
              value={selectedMarketId ? String(selectedMarketId) : ""}
              readOnly
              placeholder="Select market from dropdown above"
            />
          </label>
        </div>
        <div>
          <label className="hooks-test-label">
            Bucket ID:
            <select className="hooks-test-select" defaultValue="">
              <option value="">Select a bucket...</option>
              {buckets.map((bucket) => (
                <option key={bucket.bucketId} value={bucket.bucketId}>
                  {bucket.bucketId} ({bucket.collateralAsset})
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <button
          className="hooks-test-button"
          disabled={!selectedMarketId || buckets.length === 0}
          style={{
            width: "100%",
            padding: "20px",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          Close Position
        </button>
      </div>

      <div
        className="hooks-test-loading-state"
        style={{ marginTop: "20px", textAlign: "left" }}
      >
        Position Close functionality coming soon...
      </div>
    </div>
  );
}
